import en from '@/lang/en.json';
import fr from '@/lang/fr.json';

const MESSAGES = {
  en,
  fr,
};
const DEFAULT_LANG = 'en' as keyof typeof MESSAGES;

export {MESSAGES, DEFAULT_LANG};
